import React, { useState } from "react";
import { TextField, IconButton, Tooltip } from "@material-ui/core";
import { Delete as DeleteIcon, Check as CheckIcon, Lock as LockIcon, ArrowUpward as ArrowUpwardIcon, ArrowDownward as ArrowDownwardIcon } from "@material-ui/icons";

const PhaseFormFields = ({ phase, canMoveUp, canMoveDown, onMoveUp, onMoveDown, onSave, onDelete }) => {
  const [name, setName] = useState(phase?.name || "");
  const [color, setColor] = useState(phase?.color || "#9e9e9e");
  const isNew = !phase;
  // Fase "Pendencias" e' criada automaticamente em todo board (ver
  // CreateBoardService/Board.isPendingColumn) - nao pode ser renomeada
  // nem excluida por aqui, senao o sistema de pendencias perde a
  // referencia de qual fase usar.
  const isLocked = !!phase?.isPendingColumn;

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name, color });
    if (isNew) {
      setName("");
      setColor("#9e9e9e");
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
      {!isNew && (
        // Reordenar - pedido do usuario 2026-09-28 ("preciso poder mudar
        // cada fase de posicao, exemplo pendencias tem que ficar no
        // ultimo"). Sem trava mesmo pra fase bloqueada (Pendencias): so'
        // o NOME/COR dela sao fixos, a posicao pode mudar livremente -
        // e' exatamente o caso de uso pedido.
        <>
          <Tooltip title="Mover pra cima">
            <span>
              <IconButton size="small" disabled={!canMoveUp} onClick={onMoveUp}>
                <ArrowUpwardIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Mover pra baixo">
            <span>
              <IconButton size="small" disabled={!canMoveDown} onClick={onMoveDown}>
                <ArrowDownwardIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </>
      )}
      <input
        type="color"
        value={color}
        onChange={(e) => setColor(e.target.value)}
        // Faltava salvar a cor - so' o campo de nome tinha onBlur, entao
        // mudar SO a cor (sem tocar no nome) nunca disparava handleSave.
        // Bug real reportado 2026-08-28 ("mudei as cores das fases mais
        // nao salvou").
        onBlur={!isNew ? handleSave : undefined}
        style={{ width: 32, height: 32, border: "none", padding: 0, background: "none" }}
      />
      <TextField
        size="small"
        variant="outlined"
        placeholder="Nome da fase"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onBlur={!isNew && !isLocked ? handleSave : undefined}
        disabled={isLocked}
        fullWidth
      />
      {isNew ? (
        <IconButton size="small" onClick={handleSave} disabled={!name.trim()}>
          <CheckIcon />
        </IconButton>
      ) : isLocked ? (
        <Tooltip title="Coluna fixa do sistema de pendências">
          <span>
            <IconButton size="small" disabled>
              <LockIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      ) : (
        <IconButton size="small" onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default PhaseFormFields;
